import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
    DIFFERENT_LANGUAGE_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL,
    DIFFERENT_LANGUAGE_PRIVACY_POLICY_URL,
    DIFFERENT_LANGUAGE_TERMS_AND_CONDITIONS_URL,
    FIRST_ELEMENT_INDEX,
    GERMAN_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL,
    GERMAN_PRIVACY_POLICY_URL,
    GERMAN_TERMS_AND_CONDITIONS_URL,
    LANGUAGES,
} from '@modeso/aumico-lib-core-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IAcceptPolicyDialogData } from '../../interfaces/accepct-policy-dialog-data.interface';

@UntilDestroy()
@Component({
    selector: 'accept-policy-dialog',
    templateUrl: './accept-policy-dialog.component.html',
    styleUrls: ['./accept-policy-dialog.component.scss'],
})
export class AcceptPolicyDialogComponent {
    @Output() agreeButtonClicked = new EventEmitter<void>();
    @Output() closeButtonClicked = new EventEmitter<void>();

    constructor(
        public dialogRef: MatDialogRef<AcceptPolicyDialogComponent>,
        private domSanitizer: DomSanitizer,
        private matIconRegistry: MatIconRegistry,
        @Inject(MAT_DIALOG_DATA) public data: IAcceptPolicyDialogData,
    ) {
        this.addSvgIcon('interface-delete 1');
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    public acceptPolicy(): void {
        this.agreeButtonClicked.emit();
    }

    public closeDialog(): void {
        this.closeButtonClicked.emit();
        this.dialogRef.close();
    }

    public openTermsAndConditionsLink(): void {
        if (this.data.locale !== LANGUAGES.SWISS_GERMAN) {
            const locale = this.data.locale.split('-')[FIRST_ELEMENT_INDEX];
            const termsAndConditionsUrl = this.replaceLocaleInUrl(DIFFERENT_LANGUAGE_TERMS_AND_CONDITIONS_URL, locale);
            window.open(termsAndConditionsUrl);
        } else {
            window.open(GERMAN_TERMS_AND_CONDITIONS_URL);
        }
    }

    public openPrivacyPolicyLink(): void {
        if (this.data.locale !== LANGUAGES.SWISS_GERMAN) {
            const locale = this.data.locale.split('-')[FIRST_ELEMENT_INDEX];
            const privacyPolicyUrl = this.replaceLocaleInUrl(DIFFERENT_LANGUAGE_PRIVACY_POLICY_URL, locale);
            window.open(privacyPolicyUrl);
        } else {
            window.open(GERMAN_PRIVACY_POLICY_URL);
        }
    }

    public openAgreementOnOrderDataProcessingLink(): void {
        if (this.data.locale !== LANGUAGES.SWISS_GERMAN) {
            const locale = this.data.locale.split('-')[FIRST_ELEMENT_INDEX];
            const agreementOnOrderDataProcessingUrl = this.replaceLocaleInUrl(
                DIFFERENT_LANGUAGE_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL,
                locale,
            );
            window.open(agreementOnOrderDataProcessingUrl);
        } else {
            window.open(GERMAN_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL);
        }
    }

    private replaceLocaleInUrl(url: string, locale: string): string {
        return url.replace('{locale}', locale);
    }
}
